import ua from 'ua-parser-js'


export default function parseUserAgent () {
  const {userAgent} = navigator
  return ua(userAgent)
}


// WEBPACK FOOTER //
// ./app/parse-user-agent.js